import '.au{position:relative;}.ssr-plugin'
import '.je{width:64px;}.ssr-plugin'
import '.jf{height:64px;}.ssr-plugin'
import '.ah{flex-shrink:0;}.ssr-plugin'
import '.br{position:absolute;}.ssr-plugin'
import '.jg{bottom:-4px;}.ssr-plugin'
import '.i5{right:-4px;}.ssr-plugin'
import '.fx{border-radius:50%;}.ssr-plugin'
import '.dh{border:2px solid var(--palette-white);}.ssr-plugin'
import '.b1{overflow:hidden;}.ssr-plugin'
import '.jh{width:32px;}.ssr-plugin'
import '.ji{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="au je jf ah"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="br jg i5 fx dh b1 jh ji"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
